export const StatusChange = {
    WillRemainTheSame: 'will remain the same',
    WillIncreaseFrom: 'will increase from ',
    WillIncreaseIn1Hr: 'will increase in 1 hr',
    WillDecreaseFrom: 'will decrease from ',
    WillBeAddedFrom: 'will be added from ',
    WillRemainAt: 'will remain at ',
    WillBeRemovedFrom: 'will be removed from ',
    WillBeAdded1Hr: 'will be added in 1 hr'
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/contants/change-action-status.ts